export default "__VITE_ASSET__ChDpkZIz__"